/**
 * Models for signature API integration
 */

export interface SigningFileRequest {
  fileData: string; // base64 encoded PDF
  fileName: string;
  aggregateId: string;
  aggregateType: string;
  variable: string;
  refferenceId: string;
  aggregateCode: string;
}

export interface SignatureApiRequest {
  signingFiles: SigningFileRequest[];
  signingReason: string;
}

export interface SignatureApiResponse {
  success: boolean;
  message?: string;
  data?: any;
}

export enum SignatureType {
  IMAGE = 'IMAGE', // Signature from user-metadata field7
  USB_TOKEN = 'USB_TOKEN', // USB token signature
  HSM = 'HSM', // Hardware Security Module
  CA = 'CA', // Remote CA (requires OTP authentication)
}

/**
 * Signature Provider - based on field5 format
 * Examples:
 * - "VIETTEL-USB" → USB token from Viettel
 * - "VIETTEL-HSM" → HSM from Viettel
 * - "MYSIGN-CA" → Remote CA from MySign
 * - "" or "IMAGE" → Image signature from field7
 */
export enum SignatureProvider {
  // USB Providers
  VIETTEL_USB = 'VIETTEL-USB',
  VNPT_USB = 'VNPT-USB',
  FPT_USB = 'FPT-USB',

  // HSM Providers
  VIETTEL_HSM = 'VIETTEL-HSM',
  VNPT_HSM = 'VNPT-HSM',
  FPT_HSM = 'FPT-HSM',

  // CA Providers (Remote CA - requires OTP)
  VIETTEL_CA = 'VIETTEL-CA',
  VNPT_CA = 'VNPT-CA',
  FPT_CA = 'FPT-CA',
  MYSIGN_CA = 'MYSIGN-CA',
  ICORP_CA = 'ICORP-CA',
  EASY_CA = 'EASY-CA',
  BKAV_CA = 'BKAV-CA',

  // Image signature (default)
  IMAGE = 'IMAGE',
}

export interface SignatureConfig {
  type: SignatureType;
  provider: SignatureProvider;
  imageSignature?: string; // base64 image from field7
}

/**
 * USB Provider Domain Configuration
 * Maps each provider to its plugin service URL
 */
export const USB_PROVIDER_DOMAINS: Partial<Record<SignatureProvider, string>> = {
  [SignatureProvider.VIETTEL_USB]: 'http://127.0.0.1:14007/',
  [SignatureProvider.VNPT_USB]: 'http://127.0.0.1:14008/', // PLACEHOLDER: chưa xác nhận
  [SignatureProvider.FPT_USB]: 'http://127.0.0.1:14009/', // PLACEHOLDER: chưa xác nhận
  // HSM và CA không cần domain ở đây (sử dụng server URL từ config)
};
